// extracted by mini-css-extract-plugin
export default {"toggle":"AgendaViewToggle_toggle__-Bfbs","option":"AgendaViewToggle_option__mIJUT","active":"AgendaViewToggle_active__j95BU"};